import { browser, ua } from '../../../../util/user-agent';
import { app } from '../../../app';

app.factory('SharedSsoFactory', SharedSsoFactory);

/** @ngInject */
function SharedSsoFactory(UsersSharedAccountService, $q) {
    var authenticatorsSSO = function (sharedAccount) {
        var defered = $q.defer();

        if (sharedAccount.publicService.ssoSupported) {
            var id = sharedAccount.id;

            if (document.getElementById("saaspass-extension-info")) {
                UsersSharedAccountService.userSharedAccountSSO.getTracker(
                    { id },
                    ({ tracker }) =>
                        window.postMessage(
                            { action: "loginWithTracker", isShared: true, tracker, newTab: true },
                            "*"
                        )
                );
                return;
            }

            var hasExtensionInstalled201 = document.getElementById('extension-is-installed-v2.0.1') != null;
            var hasExtensionInstalled210 = document.getElementById('extension-is-installed-v2.1.0') != null;

            if (hasExtensionInstalled201) {
                UsersSharedAccountService.userSharedAccountSSO.get({
                    id: id,
                }, function (data) {
                    delete data["$promise"];
                    delete data["$resolved"];

                    if (ua.isChrome() || ua.isOpera()) {

                        const
                            extensionId = ua.isChrome() ? window.env.extensionIds.chrome
                                : window.env.extensionIds.opera;

                        chrome.runtime.sendMessage(extensionId, {
                            data: data,
                            message: "loginAuthenticator",
                        }, function (response) {
                            if (!response) {
                                console.log("Error extension");
                                alert("The SAASPASS Extension in not installed or disabled.");
                            } else {
                                console.log("Message sent to extension id: "
                                    + window.env.extensionIds.chrome);
                            }
                        });

                    } else if (ua.isSafari() || ua.isFirefox()) {

                        window.postMessage({
                            instructions: data,
                            message: "loginAuthenticator",
                        }, "*");

                    }

                    defered.resolve(data);
                });

            } else if (hasExtensionInstalled210) {

                // new implementation for Chrome, Firefox and Opera is tracker based
                UsersSharedAccountService.userSharedAccountSSO.getTracker({
                    id: id,
                }, function (data) {
                    // console.log(data);
                    delete data["$promise"];
                    delete data["$resolved"];

                    if (ua.isFirefox()) {

                        // Firefox does not support externally_connectable Manifest key
                        window.postMessage({
                            direction: "from-page-script",
                            message: data,
                        }, "*");
                    } else {
                        const
                            extensionId = ua.isChrome() ? window.env.extensionIds.chrome
                                : window.env.extensionIds.opera;

                        chrome.runtime.sendMessage(extensionId, {
                            data: data,
                            message: "loginWithTracker",
                        }, function (response) {
                            if (!response) {
                                console.log("SAASPASS extension not responding.");
                                alert("The SAASPASS Extension in not installed or disabled.");
                            } else {
                                console.log("Message sent to extension with id: " + extensionId);
                            }
                        });
                    }

                    defered.resolve(data);
                });
            } else {

                console.error('Please check your SAASPASS extension. Extension can be not supported, disabled or not installed in ' + browser.name + '.')
                alert('Please check your SAASPASS extension. Extension can be not supported, disabled or not installed in ' + browser.name + '.');
            }

        } else {
            window.location = sharedAccount.publicService.serviceUrl;
            defered.resolve("");
        }
        return defered.promise;
    }

    return {
        authenticatorsSSO: authenticatorsSSO,
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/shared-sso.service.js